import { useEffect } from "react";

const DEFAULT_DESCRIPTION =
  "Appazzola is a family-owned mobile app and website development company dedicated to building high-quality, user-friendly digital experiences.";

function ensureMetaTag(name) {
  let element = document.querySelector(`meta[name="${name}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }

  return element;
}

const DocumentMeta = ({
  title,
  description = DEFAULT_DESCRIPTION,
  robots = "index,follow",
}) => {
  useEffect(() => {
    document.title = title;
    ensureMetaTag("description").setAttribute("content", description);
    ensureMetaTag("robots").setAttribute("content", robots);
  }, [title, description, robots]);

  return null;
};

export default DocumentMeta;
